<template>
  <div class="go1d-form-control">
      <input
        class="go1d-input"
        v-bind:class="{ 'go1d-input-has-value': hasValue }"
        :type="type"
        :name="name"
        :autocomplete="autocomplete"
        :required="required"
        :value="value"
        @input="updateValue($event.target.value)"
      />
      <label
        class="go1d-input-label"
        v-bind:class="{ 'go1d-input-label-has-value': hasValue }"
      >
        {{label}}
      </label>

      <span
        class="go1d-input-loading"
        v-show="isLoading"
      >
        <i class="fa fa-spin fa-circle-o-notch" style="color: #5887B1;" />
      </span>
  </div>
</template>

<script>
export default {
  created: function () {
    window.addEventListener('keyup', event => {
      if (event.key == 'Enter') {
        this.$emit('enterpressed')
      }
    })
    window.addEventListener('keypress', () => this.$emit('keypress'))
  },
  computed: {
    hasValue: function() {
      return Boolean(this.value)
    }
  },
  props: [
    'label',
    'type',
    'name',
    'autocomplete',
    'required',
    'value',
    'isLoading'
  ],
  methods: {
    updateValue(value) {
      this.$emit('input', value)
    }
  },
}
</script>

<style scoped>
  .go1d-form-control {
    position: relative;
    height: 48px;
    border: 1px solid #D3D8D9;
    border-radius: 8px;
  }
  .go1d-input {
    position: absolute;
    top: 0;
    left: 0;
    height: 44px;
    width: calc(100% - 2px);
    margin: 1px;
    padding: 25px 16px 8px 16px !important;
    font-size: 16px;
    background: transparent;
    border: none;
    box-shadow: none;
    z-index: 2;
  }
  .go1d-input-has-value + .go1d-input-label,
  .go1d-input:focus + .go1d-input-label,
  .go1d-input:-webkit-autofill + .go1d-input-label {
    transform: translate(0, 4px);
    transition: transform 200ms ease-in-out;
    z-index: 3;
  }
  .go1d-input:-webkit-autofill {
    box-shadow: 0 0 0 1000px white inset !important;
    font-size: 16px;
  }
  .go1d-input:-webkit-autofill::first-line {
    font-size: 16px;
  }

  .go1d-input-label {
    font-size: 16px;
    color: rgb(102, 111, 113);
    font-weight: 400;
    line-height: 19px;
    margin: 0 16px;
    transform: translate(0, 14px);
    transition: transform 200ms ease-in-out;
    z-index: 1;
  }
  .go1d-input-label-has-value {
    transform: translate(0, 4px) !important;
    z-index: 3;
  }
  .go1d-input-label-has-value {
    transform: translate(0, 4px) !important;
  }

  .go1d-input-loading {
    position: absolute;
    right: 10px;
    top: calc(50% - 7px);
  }
</style>


// WEBPACK FOOTER //
// src/components/Generic/TextInput.vue